const initState = {
  searches:[]
  }
  
  const searchHistoryReducer = (state = initState, action) => {
    switch (action.type) {
      case 'SET_SEARCH_HISTORY':
        return { ...state, searches: action.data };
      default:
        return state;
    }
  
  };
  
  export default searchHistoryReducer;